import type { ReactNode } from "react";
import { Navigate, useParams, useSearchParams } from "react-router-dom";

import { patientSectionUrl } from "./sections";

/**
 * `/patients/:id/record` was the only way into the page the clinic likes, and
 * it was reachable only from a button inside the 94 vh drawer. The clinical
 * record is now a section of `/patients/:id`, so the old address forwards to it
 * with `replace`: the browser history keeps one entry, and Back returns to the
 * list instead of bouncing between two patient screens.
 */
export function PatientRecordRedirect() {
  const { id } = useParams<{ id: string }>();

  if (!id) return <Navigate to="/patients" replace />;

  return <Navigate to={patientSectionUrl(id, "prontuario")} replace />;
}

type PatientQueryRedirectProps = {
  children: ReactNode;
};

/**
 * `/patients?patient=<id>` used to open the drawer over the list (it is still
 * built by `form-create-scheduling`). It now forwards to the patient's own
 * page. Any other query — the list's search, filters and paging — passes
 * through untouched.
 */
export function PatientQueryRedirect({ children }: PatientQueryRedirectProps) {
  const [searchParams] = useSearchParams();
  const patientId = searchParams.get("patient");

  if (patientId) return <Navigate to={`/patients/${patientId}`} replace />;

  return <>{children}</>;
}
